(function () {
    'use strict';

    angular
        .module('app.core')
        .decorator('ngModelDirective', ngModelDirectiveDecorator);

    var forEach = angular.forEach;

    ngModelDirectiveDecorator.$inject = ['$delegate'];
    function ngModelDirectiveDecorator($delegate) {
        var directive = $delegate[0],
            prototype = directive.controller.prototype,
            setValidity = prototype.$setValidity,
            compile = directive.compile;

        directive.compile = compileProxy;
        prototype.$setValidity = setValidityProxy;
        prototype.$clearErrors = clearErrors;
        Object.defineProperty(prototype, '$showError', { get: getShowError });
        return $delegate;

        function compileProxy(scope, element, attr, ctrls) {
            var result = compile.apply(this, arguments),
                postLink = result.post;

            result.post = postLinkProxy;
            return result;

            function postLinkProxy(scope, element, attr, ctrls) {
                var modelCtrl = ctrls[0];
                postLink.apply(this, arguments);
                scope.$watch(disabledWatch, disabledWatchAction);

                function disabledWatch() {
                    return element.prop('disabled');
                }
                function disabledWatchAction(newValue, oldValue) {
                    if (newValue != oldValue) 
                        modelCtrl.$validate();
                }
            }
        }

        function setValidityProxy(validationErrorKey, state, controller) {
            if (this.$$element.prop('disabled') && state === false) 
                state = true;
            setValidity.call(this, validationErrorKey, state, controller);
        }

        function clearErrors() {
            forEach(this.$error, clearError, this);
            function clearError(_, key) {
                this.$setValidity(key, true);
            }
        }

        function getShowError() {
            return !this.$valid && (this.$touched || this.$$parentForm.$submitted);
        }
    }
})();